import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AccessStore } from '../stores/access.store';

/**
 * Restricts a route to global domainGRC admins (the "uber" grant) — the
 * gatekeeper of the /system area, which hosts operations on GLOBAL entities
 * (users, organizations, tenants, cross-org tooling).
 *
 * Reads `isUber` from the access profile (`GET /access/me`), the one
 * client-visible uber marker; the grant is a user flag, not a membership
 * property, so system pages stay available regardless of the selected org.
 * The backend's SystemAdminGuard evaluates the same flag.
 *
 * The profile loads asynchronously (see AppComponent), so on a cold
 * navigation straight to the guarded URL it may not be present yet.
 * `ensureLoaded` serves the cached profile or fetches it first — otherwise a
 * legitimate admin could be bounced to /home on a hard refresh — and emits
 * null on any error, so the guard fails closed.
 */
export const systemGuard: CanActivateFn = () => {
  const accessStore = inject(AccessStore);
  const router = inject(Router);

  return accessStore
    .ensureLoaded()
    .pipe(
      map((profile) =>
        profile?.isUber ? true : router.createUrlTree(['/home'])
      )
    );
};
